import OadpEntityButtonBatchDelete from './oadp-entity-button-batch-delete';
export default OadpEntityButtonBatchDelete;
